import { Injectable, Inject} from '@angular/core';
import {BaseDO} from './base.model';

export  class PolicyCoverageInsuredDO extends BaseDO{
    // public vehicleMakeTypeCd:string;
    // public plateNumber:string;
    // public engineNumber:string;

    public  id:Number = null;

	public roleCd:String = null;
	
	public  clientId:Number = null;
	
	public clientRefGuid:String = null;
	
	public customerId:String = null;
	
	public  vehicleId:Number = null;
	
	public vehicleRefGuid:String = null;
	
	public  propertyId:Number = null;
	
	public propertyRefGuid:String = null;
	
	public relatedToBeneficiaryCd:String = null;
	
	public medicalClassCd:String = null;
	
	public defaultSumInsured:String = null;
	
	public  entryAge:Number = null;
	
	public idType:String = null;
	
	public uwClassCd:String = null;
	
	public uwDecisionCd:String = null;
	
	public uwDecisionValue:String = null;
	
	public  policyCoverageInsuredAccessoryList = [];
	
	public  policyCoverageInsuredLoadingList = [];
	
	public  policyCoverageInsuredDiscountList = [];
	
	public policyCovInsuredInsurableList=[];

	public  policyCoverageInsuredAdditionalFieldDOs = [];

	public  mileage:Number = null;

	public ageCategoryCd:String=null;
	
	public appliedForSeatingCapacity: Number = null;

	
	public  getId() {
		return this.id;
	}
	
	public getCustomerId() {
		return this.customerId;
	}
	public setCustomerId(customerId) {
		this.customerId = customerId;
	}
	public  getEntryAge() {
		return this.entryAge;
	}
	public setEntryAge( entryAge) {
		this.entryAge = entryAge;
	}
	public getMedicalClassCd() {
		return this.medicalClassCd;
	}
	public setMedicalClassCd(medicalClassCd) {
		this.medicalClassCd = medicalClassCd;
	}
	public getRoleCd() {
		return this.roleCd;
	}
	public setRoleCd(roleCd:String) {
		this.roleCd = roleCd;
	}
	public getUwClassCd() {
		return this.uwClassCd;
	}
	public setUwClassCd(uwClassCd) {
		this.uwClassCd = uwClassCd;
	}
	public getUwDecisionCd() {
		return this.uwDecisionCd;
	}
	public setUwDecisionCd(uwDecisionCd) {
		this.uwDecisionCd = uwDecisionCd;
	}
	public getUwDecisionValue() {
		return this.uwDecisionValue;
	}
	public setUwDecisionValue(uwDecisionValue) {
		this.uwDecisionValue = uwDecisionValue;
	}
	public  getPolicyCoverageInsuredLoadingList() {
		return this.policyCoverageInsuredLoadingList;
	}
	public setPolicyCoverageInsuredLoadingList( policyCoverageInsuredLoadingList) {
		this.policyCoverageInsuredLoadingList = policyCoverageInsuredLoadingList;
	}
	public  getPolicyCoverageInsuredDiscountList() {
		return this.policyCoverageInsuredDiscountList;
	}
	public setPolicyCoverageInsuredDiscountList(
			 policyCoverageInsuredDiscountList) {
		this.policyCoverageInsuredDiscountList = policyCoverageInsuredDiscountList;
	}
	public  getPolicyCoverageInsuredAdditionalFieldDOs() {
		return this.policyCoverageInsuredAdditionalFieldDOs;
	}
	public setPolicyCoverageInsuredAdditionalFieldDOs(
			 policyCoverageInsuredAdditionalFieldDOs) {
		this.policyCoverageInsuredAdditionalFieldDOs = policyCoverageInsuredAdditionalFieldDOs;
	}
	public  getMileage() {
		return this.mileage;
	}
	public setMileage( mileage) {
		this.mileage = mileage;
	}
	public setId( id) {
		this.id = id;
	}
	public  getPolicyCoverageInsuredAccessoryList() {
		return this.policyCoverageInsuredAccessoryList;
	}
	public setPolicyCoverageInsuredAccessoryList(
			 policyCoverageInsuredAccessoryList) {
		this.policyCoverageInsuredAccessoryList = policyCoverageInsuredAccessoryList;
	}
	
	public getDefaultSumInsured() {
		return this.defaultSumInsured;
	}
	public setDefaultSumInsured(defaultSumInsured) {
		this.defaultSumInsured = defaultSumInsured;
	}
	
	public getIdType() {
		return this.idType;
	}
	public setIdType(idType) {
		this.idType = idType;
	}

	// public getObjectName() {
	// 	if (null != roleCd) {
	// 		return this.roleCd;
	// 	} else {
	// 		return this.PolicyCoverageInsuredDO.class.getSimpleName();
	// 	}
	// }

	public  getClientId() {
		return this.clientId;
	}

	public setClientId( clientId) {
		this.clientId = clientId;
	}

	public getClientRefGuid() {
		return this.clientRefGuid;
	}

	public setClientRefGuid(clientRefGuid) {
		this.clientRefGuid = clientRefGuid;
	}

	public  getVehicleId() {
		return this.vehicleId;
	}

	public setVehicleId( vehicleId) {
		this.vehicleId = vehicleId;
	}

	public getVehicleRefGuid() {
		return this.vehicleRefGuid;
	}

	public setVehicleRefGuid(vehicleRefGuid) {
		this.vehicleRefGuid = vehicleRefGuid;
	}

	public getRelatedToBeneficiaryCd() {
		return this.relatedToBeneficiaryCd;
	}

	public setRelatedToBeneficiaryCd(relatedToBeneficiaryCd) {
		this.relatedToBeneficiaryCd = relatedToBeneficiaryCd;
	}

	public getAppliedForSeatingCapacity() {
		return this.appliedForSeatingCapacity;
	}
	public setAppliedForSeatingCapacity(appliedForSeatingCapacity) {
		this.appliedForSeatingCapacity = appliedForSeatingCapacity;
	}
}
